import { escapeCsvValue, hasExportValue } from '../../../helpers/utils'
import { UI_TEXT_NA } from '../../../constants/uiText'
import { REFUND_APPROVAL_TEXT } from '../../constants/refundApprovalText'
import { REFUND_PRODUCTS_TABLE_HEADERS } from '../../helpers/refundApprovalUtils'
import {
  getAttachmentLabel,
  isImageUrl,
  normalizeAttachmentList
} from '../../../helpers/paymentAttachments'

const getUrlPath = (url = '') => String(url).split(/[?#]/, 1)[0].toLowerCase()
const isPdfUrl = (url = '') =>
  getUrlPath(url).endsWith('.pdf') || /^data:application\/pdf/i.test(url)

const normalizeCsvAttachments = ({ images = [], files = [] } = {}) => {
  const normalizedImages = normalizeAttachmentList(images)
  const normalizedFiles = normalizeAttachmentList(files)
  const imageFiles = normalizedFiles.filter(
    (file) => isImageUrl(file) || /^data:image\//i.test(file.url)
  )
  const mergedImages = [...normalizedImages, ...imageFiles].reduce((acc, item) => {
    if (!acc.some((current) => current.url === item.url)) acc.push(item)
    return acc
  }, [])
  const mergedFiles = normalizedFiles.filter(
    (file) => !mergedImages.some((image) => image.url === file.url)
  )

  return [
    ...mergedImages.map((attachment) => ({ ...attachment, type: 'Imagen' })),
    ...mergedFiles.map((attachment) => ({
      ...attachment,
      type: isPdfUrl(attachment.url) ? 'PDF' : 'Archivo'
    }))
  ]
}

const buildDetailsRows = (fields) => fields.map((field) => [field.label || '', field.value ?? ''])

export const buildRefundApprovalCsvContent = ({
  activity,
  headerData,
  summaryFields = [],
  fieldsToRender = [],
  attachments = {},
  tableExportRows = []
}) => {
  const createdAt =
    headerData?.display_created_date ||
    activity?.created_date ||
    activity?.created_at ||
    activity?.collected_at ||
    UI_TEXT_NA

  const detailFields = [...summaryFields, ...fieldsToRender].filter(
    (field) => field?.label && hasExportValue(field.value)
  )
  const normalizedAttachments = normalizeCsvAttachments(attachments)
  const salesmanCode = activity?.salesman_db_ref || headerData?.salesman_db_ref || UI_TEXT_NA
  const salesmanName = activity?.salesman_name || headerData?.salesman_name || UI_TEXT_NA
  const refundRef =
    activity?.refund_db_ref ||
    headerData?.refund_db_ref ||
    activity?.uuid ||
    headerData?.uuid ||
    UI_TEXT_NA

  const rows = [
    ['Devolución'],
    ['N° de Devolución:', refundRef],
    ['N° NCR:', activity?.ncr_number || headerData?.ncr_number || '-'],
    ['Usuario:', `${salesmanCode} - ${salesmanName}`],
    ['Fecha de creación:', createdAt],
    []
  ]

  if (detailFields.length > 0) {
    rows.push(['Detalles de devolución'])
    rows.push(['Campo', 'Valor'])
    rows.push(...buildDetailsRows(detailFields))
    rows.push([])
  }

  rows.push(['Productos en devolución'])
  rows.push([REFUND_APPROVAL_TEXT.productsRecord])
  rows.push(REFUND_PRODUCTS_TABLE_HEADERS)
  rows.push(...tableExportRows)

  if (normalizedAttachments.length > 0) {
    rows.push([])
    rows.push(['Adjuntos'])
    rows.push(['#', 'Tipo', 'Nombre', 'URL'])
    normalizedAttachments.forEach((attachment, index) => {
      rows.push([
        `Adjunto ${index + 1}`,
        attachment.type,
        getAttachmentLabel(attachment, `Adjunto ${index + 1}`),
        attachment.url
      ])
    })
  }

  return rows.map((row) => row.map(escapeCsvValue).join(',')).join('\n')
}
